function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useFormContext } from '../FormContext';
import YesOrNotButtons from '../../yes-or-not-buttons/YesOrNotButtons';
const YesOrNotButtonsAdapter = _ref => {
  let {
    name,
    ...rest
  } = _ref;
  const {
    values
  } = useFormContext();
  return /*#__PURE__*/React.createElement(YesOrNotButtons, _extends({
    name: name,
    value: values[name]
  }, rest));
};
export default YesOrNotButtonsAdapter;
//# sourceMappingURL=YesOrNotButtonsAdapter.js.map